import React, { useEffect, useState, useRef } from 'react';
import useAuth from '../../hooks/useAuth';
import { getUserDisplayNameMapFromFirestore } from '../../firebase/getUserDisplayNameMapFromFirestore';
import PostCard from '../../Components/PostCard/PostCard';
import styles from './Home.module.css';
import { useNavigate, Link } from 'react-router-dom';
import { getPostsFromFirestore, getMorePostsFromFirestore } from '../../firebase/postService';

const Home = () => {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const lastPostRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [lastDoc, setLastDoc] = useState(null);
  const { user } = useAuth();
  const [displayNameMap, setDisplayNameMap] = useState({});

  // usersコレクションから全ユーザーのuid→displayNameマップを取得
  useEffect(() => {
    async function fetchDisplayNameMap() {
      const map = await getUserDisplayNameMapFromFirestore();
      setDisplayNameMap(map);
    }
    fetchDisplayNameMap();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const data = await getPostsFromFirestore();
        setPosts(data);
        setHasMore(data.length === 10);
        setLastDoc(data.length > 0 ? { ...data[data.length - 1] } : null);
      } catch (e) {
        setPosts([]);
        setHasMore(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // 追加取得
  const handleLoadMore = async (event) => {
    if (event && event.preventDefault) event.preventDefault();
    if (!lastDoc) return;
    // 現在のスクロール位置を記憶
    const prevScroll = window.scrollY;
    setLoading(true);
    try {
      // Firestoreのドキュメント参照を取得
      const db = (await import('firebase/firestore')).getFirestore((await import('../../firebase/firebaseConfig')).getFirebaseApp());
      const docRef = (await import('firebase/firestore')).doc(db, 'posts', lastDoc.id);
      const docSnap = await (await import('firebase/firestore')).getDoc(docRef);
      if (!docSnap.exists()) {
        setHasMore(false);
        setLoading(false);
        return;
      }
      const more = await getMorePostsFromFirestore(docSnap);
      setPosts(prev => {
        const newPosts = [...prev, ...more];
        setTimeout(() => {
          if (lastPostRef.current) {
            lastPostRef.current.scrollIntoView({ behavior: 'auto', block: 'end' });
          }
        }, 0);
        return newPosts;
      });
      setHasMore(more.length === 10);
      setLastDoc(more.length > 0 ? { ...more[more.length - 1] } : lastDoc);
      // 投稿追加後に元の位置へ戻す
      setTimeout(() => {
        window.scrollTo({ top: prevScroll, behavior: 'auto' });
      }, 0);
    } catch (e) {
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h1>プラモデル管理アプリ</h1>
      <p>道具や作品を管理・投稿できるWebアプリです。</p>
      <div style={{marginTop:32, textAlign:'left'}}>
        <h2 style={{marginBottom:12}}>投稿一覧</h2>
        {loading ? (
          <div>読み込み中...</div>
        ) : posts.length === 0 ? (
          <div>まだ投稿がありません。</div>
        ) : (
          <>
            <ul style={{padding:0, listStyle:'none'}}>
              {posts.map((post, idx) => (
                idx === posts.length - 1 ? (
                  <li
                    ref={lastPostRef}
                    key={post.id}
                    style={{marginBottom:24, background:'#f8f8f8', borderRadius:8, padding:16, listStyle:'none'}}>
                    <PostCard post={{ ...post, displayName: displayNameMap[post.uid] || post.displayName || '名無し' }} />
                  </li>
                ) : (
                  <li
                    key={post.id}
                    style={{marginBottom:24, background:'#f8f8f8', borderRadius:8, padding:16, listStyle:'none'}}>
                    <PostCard post={{ ...post, displayName: displayNameMap[post.uid] || post.displayName || '名無し' }} />
                  </li>
                )
              ))}
            </ul>
            {hasMore && (
              <button type="button" onClick={handleLoadMore} className={styles.button} style={{margin:'24px auto',display:'block'}}>続きを見る</button>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
